import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Plus, Pencil, Trash2, ExternalLink } from "lucide-react";
import { toast } from "sonner";
import { api, formatDate } from "@/lib/api";
import { PageHeader, StatusBadge, adminBtnPrimary } from "@/components/admin/ui";

export default function AdminArticles() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => api.get("/admin/articles").then((r) => { setItems(r.data); setLoading(false); }).catch(() => setLoading(false));
  useEffect(() => { load(); }, []);

  const remove = async (id) => {
    if (!window.confirm("Delete this article? This cannot be undone.")) return;
    await api.delete(`/admin/articles/${id}`);
    toast.success("Article deleted");
    load();
  };

  return (
    <>
      <PageHeader title="Articles" subtitle="Create, edit and publish articles.">
        <Link to="/admin/articles/new" className={adminBtnPrimary} data-testid="new-article-button"><Plus className="h-4 w-4" /> New Article</Link>
      </PageHeader>

      <div className="overflow-hidden border border-ink/10 bg-cream-100">
        <table className="w-full text-left">
          <thead>
            <tr className="border-b border-ink/10 font-sans text-xs uppercase tracking-wide text-steel-500">
              <th className="px-5 py-3">Title</th>
              <th className="px-5 py-3">Category</th>
              <th className="px-5 py-3">Status</th>
              <th className="px-5 py-3">Updated</th>
              <th className="px-5 py-3 text-right">Actions</th>
            </tr>
          </thead>
          <tbody>
            {items.map((a) => (
              <tr key={a.id} className="border-b border-cream-200 last:border-0" data-testid={`admin-article-row-${a.id}`}>
                <td className="px-5 py-4">
                  <Link to={`/admin/articles/${a.id}`} className="font-sans text-sm font-medium text-ink hover:text-gold-600">{a.title || "Untitled"}</Link>
                  {a.featured && <span className="ml-2 font-sans text-xs text-gold-600">★ Featured</span>}
                </td>
                <td className="px-5 py-4 font-sans text-sm text-steel-600">{a.category || "—"}</td>
                <td className="px-5 py-4"><StatusBadge status={a.status} /></td>
                <td className="px-5 py-4 font-sans text-sm text-steel-500">{formatDate(a.updated_at)}</td>
                <td className="px-5 py-4">
                  <div className="flex items-center justify-end gap-2">
                    {a.status === "published" && (
                      <a href={`/articles/${a.slug}`} target="_blank" rel="noreferrer" className="text-steel-500 hover:text-gold-600" title="View"><ExternalLink className="h-4 w-4" /></a>
                    )}
                    <Link to={`/admin/articles/${a.id}`} className="text-steel-500 hover:text-gold-600" title="Edit"><Pencil className="h-4 w-4" /></Link>
                    <button onClick={() => remove(a.id)} className="text-steel-500 hover:text-destructive" title="Delete" data-testid={`delete-article-${a.id}`}><Trash2 className="h-4 w-4" /></button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {!loading && items.length === 0 && <p className="py-16 text-center font-sans text-sm text-steel-400">No articles yet. Create your first article to get started.</p>}
        {loading && <p className="py-16 text-center font-sans text-sm text-steel-400">Loading…</p>}
      </div>
    </>
  );
}
